import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../actions/labourActions';
import * as api from '../api/afterSalesDataServices';
import { loadIscilik, saveIscilik } from 'src/utils/storage/Labour'
function* getLabours(kulModelKodu, garantiTipi, hizmetKodu) {
  try {
    if(!kulModelKodu.kulModelKodu){
      throw new Error('Model Kodu Girilmemiş');
    }
    let data = loadIscilik(kulModelKodu.kulModelKodu);
    if (data.length === 0 && window.navigator.onLine){
      const result = yield call(api.getLabours, kulModelKodu, garantiTipi, hizmetKodu);
      data = result.data === "" ? [] : result.data;
      saveIscilik(kulModelKodu.kulModelKodu, data);
    }
    yield put(actions.getLabourSuccess(data));
  } catch (error) {
    yield put(actions.setLabourError(error));
  }
}

function* watchGetLabourRequest() {
  yield takeEvery(actions.Types.GET_LABOUR_REQUEST, getLabours);
}

const labourSagas = [fork(watchGetLabourRequest)];

export default labourSagas;
